<template>
  <div class="branch-item">
    <div class="branch-item__branch-info">
      <div class="branch-item__branch-name">{{ branchName }}</div>
      <div class="branch-item__accountant-name">
        <strong>{{ accountantName }} 세무사</strong>
        <span
          v-show="homepage"
          class="branch-item__accountant-name-homepage-url"
        >
          <a :href="homepage" target="_blank">홈페이지</a>
        </span>
      </div>
      <div class="branch-item__address">
        <span class="branch-item__address-text">{{ address }}</span>
        <span v-show="mapUrl" class="branch-item__address-url">
          <a :href="mapUrl" target="_blank">지도 보기</a>
        </span>
      </div>
      <div v-show="phoneNumber" class="branch-item__phone-number">
        <a :href="`tel:${phoneNumber}`">{{ phoneNumber }}</a>
      </div>
    </div>
    <div class="branch-item__photo">
      <img :src="file.fields.branchLogo.fields.file.url" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BranchItem',
  filters: {
    convertName(name) {
      return name.replace('-', '/')
    }
  },
  props: {
    file: {
      type: Object,
      default: undefined
    },
    dummyPhoto: {
      type: Boolean
    },
    branchName: {
      type: String,
      required: true
    },
    accountantName: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    },
    mapUrl: {
      type: String,
      default: undefined
    },
    phoneNumber: {
      type: String,
      default: undefined
    },
    homepage: {
      type: String,
      default: undefined
    }
  },
  computed: {
    photoImgUrl() {
      if (this.dummyPhoto) {
        return `/images/heum-branch/dummy`
      } else {
        return `/images/heum-branch/${this.accountantName}세무사`
      }
    }
  }
}
</script>

<style scoped lang="scss">
.branch-item {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  padding: 32px 20px;
  background-color: #fff;
  box-shadow: 0px 0px 16px rgba(164, 164, 164, 0.16);
  color: #4d4e58;

  @include av-mq(lap-and-up) {
    padding: 54px 68px;
  }

  &__branch-info {
    * {
      margin-bottom: 8px;
      word-break: keep-all;

      @include av-mq(lap-and-up) {
        margin-bottom: 16px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    a {
      text-decoration: none;
      color: inherit;
    }
  }

  &__photo {
    height: 90px;

    @include av-mq(lap-and-up) {
      height: 184px;
    }

    img {
      height: 100%;
      border-radius: 16px;
      @include av-mq(lap-and-up) {
        border-radius: 32px;
      }
    }
  }

  &__branch-name {
    font-size: 12px;
    line-height: 15px;
    @include av-mq(lap-and-up) {
      font-size: 20px;
      line-height: 25px;
    }
  }

  &__accountant-name {
    display: flex;
    align-items: center;

    strong {
      margin-right: 0.5rem;
      font-weight: bold;
      font-size: 18px;
      line-height: 23px;
      @include av-mq(lap-and-up) {
        font-size: 28px;
        line-height: 35px;
      }
    }

    &-homepage-url {
      display: inline-block;
      padding: 6px 13px 6px 10px;
      border: 1px solid #cbd0da;
      box-sizing: border-box;
      border-radius: 100px;
      font-size: 12px;
      line-height: 16px;
      cursor: pointer;

      @include av-mq(lap-and-up) {
        display: inline-block;
        margin: 0;
      }

      &:before {
        vertical-align: bottom;
        display: inline-block;
        margin-right: 5px;
        content: '';
        width: 13px;
        height: 16px;
        background-image: url('/images/heum-branch/ico_home.png');
        background-size: 13px 16px;
      }
    }
  }

  &__address {
    font-size: 12px;
    line-height: 15px;

    @include av-mq(lap-and-up) {
      font-size: 16px;
      line-height: 20px;
    }

    &-text {
      margin-right: 8px;
    }

    &-url {
      display: block;

      @include av-mq(lap-and-up) {
        display: inline-block;
        margin: 0;
      }
    }

    a {
      display: inline-block;
      margin-top: 0.5rem;
      padding: 6px 13px 6px 10px;
      border: 1px solid #cbd0da;
      box-sizing: border-box;
      border-radius: 100px;
      font-size: 12px;
      line-height: 16px;

      @include av-mq(lap-and-up) {
        display: inline-block;
        margin: 0;
      }

      &:before {
        vertical-align: bottom;
        display: inline-block;
        margin-right: 5px;
        content: '';
        width: 13px;
        height: 16px;
        background-image: url('/images/heum-branch/ico_map.png');
      }
    }
  }

  &__phone-number {
    font-size: 11px;
    line-height: 14px;

    @include av-mq(lap-and-up) {
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>
